import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BiArrowBack } from 'react-icons/bi';
import { MdDelete, MdAdd } from 'react-icons/md';
import { AiOutlineCheckCircle } from 'react-icons/ai';

const stateData = [
    { label: 'Alabama', value: 'Alabama' },
    { label: 'Alaska', value: 'Alaska' },
    { label: 'Arizona', value: 'Arizona' },
    { label: 'Arkansas', value: 'Arkansas' },
    { label: 'California', value: 'California' },
    { label: 'Colorado', value: 'Colorado' },
    { label: 'Connecticut', value: 'Connecticut' },
    { label: 'Delaware', value: 'Delaware' },
    { label: 'Florida', value: 'Florida' },
    { label: 'Georgia', value: 'Georgia' },
    { label: 'Hawaii', value: 'Hawaii' },
    { label: 'Idaho', value: 'Idaho' },
    { label: 'Illinois', value: 'Illinois' },
    { label: 'Indiana', value: 'Indiana' },
    { label: 'Iowa', value: 'Iowa' },
    { label: 'Kansas', value: 'Kansas' },
    { label: 'Kentucky', value: 'Kentucky' },
    { label: 'Louisiana', value: 'Louisiana' },
    { label: 'Maine', value: 'Maine' },
    { label: 'Maryland', value: 'Maryland' },
    { label: 'Massachusetts', value: 'Massachusetts' },
    { label: 'Michigan', value: 'Michigan' },
    { label: 'Minnesota', value: 'Minnesota' },
    { label: 'Mississippi', value: 'Mississippi' },
    { label: 'Missouri', value: 'Missouri' },
    { label: 'Montana', value: 'Montana' },
    { label: 'Nebraska', value: 'Nebraska' },
    { label: 'Nevada', value: 'Nevada' },
    { label: 'New Hampshire', value: 'New Hampshire' },
    { label: 'New Jersey', value: 'New Jersey' },
    { label: 'New Mexico', value: 'New Mexico' },
    { label: 'New York', value: 'New York' },
    { label: 'North Carolina', value: 'North Carolina' },
    { label: 'North Dakota', value: 'North Dakota' },
    { label: 'Ohio', value: 'Ohio' },
    { label: 'Oklahoma', value: 'Oklahoma' },
    { label: 'Oregon', value: 'Oregon' },
    { label: 'Pennsylvania', value: 'Pennsylvania' },
    { label: 'Rhode Island', value: 'Rhode Island' },
    { label: 'South Carolina', value: 'South Carolina' },
    { label: 'South Dakota', value: 'South Dakota' },
    { label: 'Tennessee', value: 'Tennessee' },
    { label: 'Texas', value: 'Texas' },
    { label: 'Utah', value: 'Utah' },
    { label: 'Vermont', value: 'Vermont' },
    { label: 'Virginia', value: 'Virginia' },
    { label: 'Washington', value: 'Washington' },
    { label: 'West Virginia', value: 'West Virginia' },
    { label: 'Wisconsin', value: 'Wisconsin' },
    { label: 'Wyoming', value: 'Wyoming' }
];

const storageData = [
    { label: 'Chicago Storage', value: 'Chicago Storage' },
    { label: 'Arkansas Storage', value: 'Arkansas Storage' },
    { label: 'Columbus Storage', value: 'Columbus Storage' }
];

const CheckoutForm = () => {
    const navigate = useNavigate();
    const [date] = useState(new Date());
    const [username, setUsername] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [storage, setStorage] = useState("");
    const [barcodeInput, setBarcodeInput] = useState("");
    const [barcodes, setBarcodes] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [loadingSerialNumbers, setLoadingSerialNumbers] = useState(false);

    useEffect(() => {
        const storedUsername = localStorage.getItem("apUsername");
        if (storedUsername) {
            setUsername(storedUsername);
        }
    }, []);

    const addBarcode = () => {
        if (!barcodeInput.trim()) {
            alert('Please enter a barcode number');
            return;
        }

        const trimmedBarcode = barcodeInput.trim();
        const existingBarcode = barcodes.find(b => b.barcodeNumber === trimmedBarcode);
        
        if (existingBarcode) {
            alert('This barcode is already in the list');
            setBarcodeInput("");
            return;
        }

        const newBarcode = {
            id: Date.now() + Math.random(),
            barcodeNumber: trimmedBarcode,
            serialNumber: null
        };

        setBarcodes([...barcodes, newBarcode]);
        setBarcodeInput("");
    };

    const deleteBarcode = (id) => {
        if (window.confirm('Are you sure you want to delete this barcode?')) {
            setBarcodes(barcodes.filter(b => b.id !== id));
        }
    };

    const fetchSerialNumbers = async () => {
        if (barcodes.length === 0) {
            alert('Please add barcodes first before fetching serial numbers.');
            return;
        }

        setLoadingSerialNumbers(true);
        try {
            const token = localStorage.getItem("apUserToken");
            
            if (!token) {
                alert('Authentication token not found. Please login again.');
                setLoadingSerialNumbers(false);
                return;
            }

            const barcodeNumbers = barcodes.map(item => item.barcodeNumber);

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}checkoutForm/get-serial-numbers`,
                {
                    scanned_barcodes: barcodeNumbers
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            const serialNumberMap = {};
            
            if (response.data?.data && Array.isArray(response.data.data)) {
                response.data.data.forEach(item => {
                    if (item.ap_inventory_barcode && item.ap_equipment_id_number) {
                        serialNumberMap[item.ap_inventory_barcode] = item.ap_equipment_id_number;
                    }
                });
            }

            setBarcodes(prevBarcodes => {
                return prevBarcodes.map(item => ({
                    ...item,
                    serialNumber: serialNumberMap[item.barcodeNumber] || item.serialNumber || 'N/A'
                }));
            });
            
            alert('Serial numbers fetched successfully!');
        } catch (error) {
            console.error('Error fetching serial numbers:', error);
            const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch serial numbers. Please try again.';
            alert('Error: ' + errorMessage);
        } finally {
            setLoadingSerialNumbers(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            addBarcode();
        }
    };

    const validateForm = () => {
        if (!customerName.trim()) {
            alert('Please enter customer name');
            return false;
        }
        if (!city.trim()) {
            alert('Please enter city');
            return false;
        }
        if (!state) {
            alert('Please select a state');
            return false;
        }
        if (!storage) {
            alert('Please select a storage');
            return false;
        }
        if (barcodes.length === 0) {
            alert('Please add at least one barcode');
            return false;
        }
        return true;
    };

    const submitForm = async () => {
        if (!validateForm()) {
            return;
        }

        if (!window.confirm('Are you sure all the barcode numbers are correct?')) {
            return;
        }

        setIsSubmitting(true);
        try {
            const token = localStorage.getItem("apUserToken");

            if (!token) {
                alert('Authentication token not found. Please login again.');
                setIsSubmitting(false);
                return;
            }

            const formData = {
                customer_name: customerName,
                city: city,
                state: state,
                storage: storage,
                technician_name: username,
                scanned_barcodes: JSON.stringify(barcodes.map(item => ({
                    barcodeNumber: item.barcodeNumber,
                    serialNumber: item.serialNumber
                }))),
                submission_date: new Date().toISOString(),
                total_barcodes: barcodes.length
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}checkoutForm/checkout-form`,
                formData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            if (response.data && response.data.success) {
                setShowSuccessDialog(true);
            } else {
                alert(response.data?.message || 'Failed to submit form. Please try again.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Failed to submit form. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSuccessDialogClose = () => {
        setShowSuccessDialog(false);
        // Reset form
        setCustomerName("");
        setCity("");
        setState("");
        setStorage("");
        setBarcodes([]);
        setBarcodeInput("");
        navigate('/home');
    };

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Header */}
            <div className="bg-teal-600 text-white p-4 shadow-md">
                <div className="flex items-center gap-4">
                    <button onClick={() => navigate('/home')} className="text-white hover:text-gray-200">
                        <BiArrowBack size={24} />
                    </button>
                    <h1 className="text-2xl font-bold">Checkout Form</h1>
                </div>
            </div>

            {/* Form */}
            <div className="container mx-auto p-4 max-w-4xl">
                <div className="bg-white rounded-lg shadow-md p-6 mb-4">
                    <h2 className="text-xl font-bold mb-4 text-center">Checkout Form</h2>

                    <div className="space-y-4">
                        <div className="flex items-center gap-4">
                            <label className="w-40 font-medium text-red-600">Date*:</label>
                            <span>{new Date(date).toLocaleString()}</span>
                        </div>

                        <div className="flex items-center gap-4">
                            <label className="w-40 font-medium text-red-600">User*:</label>
                            <span>{username || 'N/A'}</span>
                        </div>

                        <div className="flex items-center gap-4">
                            <label className="w-40 font-medium text-red-600">Meters Going To*:</label>
                            <input
                                type="text"
                                className="flex-1 border border-gray-300 rounded px-3 py-2"
                                placeholder="Enter Customer Name"
                                value={customerName}
                                onChange={(e) => setCustomerName(e.target.value)}
                            />
                        </div>

                        <div className="flex items-center gap-4">
                            <label className="w-40 font-medium text-red-600">City*:</label>
                            <input
                                type="text"
                                className="flex-1 border border-gray-300 rounded px-3 py-2"
                                placeholder="Enter City"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                            />
                        </div>

                        <div className="flex items-center gap-4">
                            <label className="w-40 font-medium text-red-600">State*:</label>
                            <select
                                className="flex-1 border border-gray-300 rounded px-3 py-2"
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                            >
                                <option value="">Select State</option>
                                {stateData.map((stateItem) => (
                                    <option key={stateItem.value} value={stateItem.value}>
                                        {stateItem.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="flex items-center gap-4">
                            <label className="w-40 font-medium text-red-600">Checkout Location*:</label>
                            <select
                                className="flex-1 border border-gray-300 rounded px-3 py-2"
                                value={storage}
                                onChange={(e) => setStorage(e.target.value)}
                            >
                                <option value="">Select Storage</option>
                                {storageData.map((storageItem) => (
                                    <option key={storageItem.value} value={storageItem.value}>
                                        {storageItem.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                {/* Barcode Entry Section */}
                <div className="bg-white rounded-lg shadow-md p-6 mb-4">
                    <h3 className="text-lg font-bold mb-4">Barcodes</h3>
                    
                    <div className="flex gap-2 mb-4">
                        <input
                            type="text"
                            className="flex-1 border border-gray-300 rounded px-3 py-2"
                            placeholder="Enter Barcode Number"
                            value={barcodeInput}
                            onChange={(e) => setBarcodeInput(e.target.value)}
                            onKeyPress={handleKeyPress}
                        />
                        <button
                            onClick={addBarcode}
                            className="px-4 py-2 bg-teal-600 text-white rounded hover:bg-teal-700 flex items-center gap-2"
                        >
                            <MdAdd size={20} />
                            <span>Add</span>
                        </button>
                    </div>

                    <div className="mb-4">
                        <button
                            onClick={fetchSerialNumbers}
                            disabled={loadingSerialNumbers || barcodes.length === 0}
                            className={`px-4 py-2 rounded ${
                                loadingSerialNumbers || barcodes.length === 0
                                    ? 'bg-gray-400 cursor-not-allowed'
                                    : 'bg-blue-600 text-white hover:bg-blue-700'
                            }`}
                        >
                            {loadingSerialNumbers ? 'Fetching...' : 'Fetch Serial Numbers'}
                        </button>
                    </div>

                    {barcodes.length > 0 && (
                        <div className="overflow-x-auto">
                            <table className="w-full border-collapse border border-gray-300">
                                <thead>
                                    <tr className="bg-gray-50">
                                        <th className="border border-gray-300 px-4 py-2">#</th>
                                        <th className="border border-gray-300 px-4 py-2">AP Barcode No.</th>
                                        <th className="border border-gray-300 px-4 py-2">Meter Serial No.</th>
                                        <th className="border border-gray-300 px-4 py-2">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {barcodes.map((barcode, index) => (
                                        <tr key={barcode.id}>
                                            <td className="border border-gray-300 px-4 py-2 text-center">{index + 1}</td>
                                            <td className="border border-gray-300 px-4 py-2">{barcode.barcodeNumber}</td>
                                            <td className="border border-gray-300 px-4 py-2">
                                                {barcode.serialNumber || 'Not fetched'}
                                            </td>
                                            <td className="border border-gray-300 px-4 py-2 text-center">
                                                <button
                                                    onClick={() => deleteBarcode(barcode.id)}
                                                    className="text-red-600 hover:text-red-800"
                                                >
                                                    <MdDelete size={20} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                {/* Submit Button */}
                <div className="flex gap-4 mb-6">
                    <button
                        onClick={submitForm}
                        disabled={isSubmitting}
                        className={`flex-1 px-6 py-3 rounded-lg font-semibold ${
                            isSubmitting
                                ? 'bg-gray-400 cursor-not-allowed'
                                : 'bg-teal-600 text-white hover:bg-teal-700'
                        }`}
                    >
                        {isSubmitting ? 'Submitting...' : 'Submit Form'}
                    </button>
                </div>
            </div>

            {/* Success Dialog */}
            {showSuccessDialog && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-8 max-w-md mx-4 shadow-xl">
                        <div className="flex justify-center mb-4">
                            <AiOutlineCheckCircle size={60} className="text-green-500" />
                        </div>
                        <h3 className="text-xl font-bold text-center mb-4">Success!</h3>
                        <p className="text-center text-gray-600 mb-6">
                            Your checkout form has been submitted successfully.
                        </p>
                        <button
                            onClick={handleSuccessDialogClose}
                            className="w-full px-6 py-3 bg-teal-600 text-white rounded-lg font-semibold hover:bg-teal-700"
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CheckoutForm;

